import { Company } from "@lib/types/jobTypes";
import slugifyString from "../string/slugifyString";
import getOriginUrl from "./getOriginUrl";

export default function getCompanyUrl(
  company: Company,
  withOrigin: boolean = true
) {
  return `${withOrigin ? getOriginUrl() : ""}/companies/${
    company.id
  }/${slugifyString(company.name)}`;
}
